export default "__VITE_ASSET__DhHhw8TY__"